import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {setWalkThroughStatus} from '../../store/actions/suites';
import { fetchSuiteWalkThroughs } from '../../store/actions/walkThroughs'
import { selectSuites } from '../../store/selectors/suites';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { setSearch, clearSearch } from '../../store/actions/search';
import Loader from '../../components/Loader'
import { selectPRLoader } from '../../store/selectors/PropertyLoader';

import WalkThroughTable from '../../components/WalkThroughTable'
import { selectWalkThrough } from '../../store/selectors/walkThrough';

class SuiteWalkThroughs extends Component {
  componentDidMount() {
    const { suite, fetchSuiteWalkThroughs, user } = this.props;
    const roleName = user.roles[0].role.name;
    fetchSuiteWalkThroughs(suite.id, roleName, true)
  }

  render() {
    const { suite,property,walkThroughs, loader } = this.props;
    return (
      loader ? <Loader /> :
      <WalkThroughTable 
          suite={suite}
          property={property}
          walkThroughs={walkThroughs}
          isEventShow={this.props.isEventShow}
          onSearch={e => setSearch({ walkThroughs: e.target.value.trim() })}
          onOfflineActivities={this.onOfflineActivities}
      />
    )
    }

}

const mapStateToProps = (state, ownProps) => {
  let user = selectAuthenticatedUser(state);
  return {
    user,
    suites: selectSuites(state),
    walkThroughs:selectWalkThrough(state),
    loader: selectPRLoader(state)
  }  
};

const mapDispatchToProps = dispatch => bindActionCreators({
  setSearch,
  clearSearch,
  setWalkThroughStatus: setWalkThroughStatus,
  fetchSuiteWalkThroughs,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SuiteWalkThroughs);
